// NAV PATHS

export const NAV_PATH_HOME = 'home';
export const NAV_PATH_JOBS = 'jobs';
export const NAV_PATH_EDUCATION = 'education';
export const NAV_PATH_SKILLS = 'skills';
export const NAV_PATH_PORTFOLIO = 'portfolio';

export const GROUP_LOADER = 'loader';
export const GROUP_COVER = 'cover';
export const GROUP_PAGELIST = 'pagelist';


// WEBPACK FOOTER //
// ./app/assets/js/shared/constants.js